import React from "react";
import Helper from "./helper";
import HelperSidebar from "./helpersidebar";

function HelperDashboard(props) {
  return (
    <>
      <HelperSidebar />
      <Helper />
    </>
  );
}

export default HelperDashboard;
